module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm2_jp.7f39f1dc06264f248bcce04575198be6.png";